import { render, staticRenderFns } from "./PhotoTargetSetting.vue?vue&type=template&id=33a3ef32&scoped=true"
import script from "./PhotoTargetSetting.vue?vue&type=script&lang=js"
export * from "./PhotoTargetSetting.vue?vue&type=script&lang=js"
import style0 from "./PhotoTargetSetting.vue?vue&type=style&index=0&id=33a3ef32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3ef32",
  null
  
)

export default component.exports